import { useParams } from 'react-router';
import { Alert, Button, Flex, Tooltip } from 'antd';

import useAccountQuery from 'hooks/useAccountQuery';
import { useAccountLevelActions } from '../CreditAccountPage';
import { ACCOUNT_STATUS_CODE } from 'utilities/constants';
import { RESTRICTIVE_TIERED_WATCH_REASONS } from 'utilities/accountStatusConstants';

const StatementPreferences = () => {
  const { accountId, customerId } = useParams();
  const { statementPreferencesModal, statementPreferences } =
    useAccountLevelActions();

  const { statuses } = useAccountQuery(customerId, accountId);

  // ineligibility defined in cc-accounts:
  // https://github.com/missionlane/cc-accounts/blob/10b9285eecec266ce452cab89478be9162f8b4f1/application/src/main/kotlin/com/missionlane/ccaccounts/service/StatementInformationServiceImpl.kt#L135
  const ineligibleStatusCodes = [
    ACCOUNT_STATUS_CODE.BANKTRUPTCY,
    ACCOUNT_STATUS_CODE.CHARGED_OFF,
    ACCOUNT_STATUS_CODE.CONFIRMED_FRAUD,
    ACCOUNT_STATUS_CODE.DECEASED,
    ACCOUNT_STATUS_CODE.CREDIT_REVOKED,
    ACCOUNT_STATUS_CODE.RETURNED_MAIL,
    ACCOUNT_STATUS_CODE.TIERED_WATCH,
    ACCOUNT_STATUS_CODE.SECURITY_FRAUD,
  ];

  const ineligibileToUpdateText = statuses
    .filter((status) => {
      if (status.statusCode === ACCOUNT_STATUS_CODE.TIERED_WATCH) {
        return RESTRICTIVE_TIERED_WATCH_REASONS.includes(status.reasonCode);
      }

      return ineligibleStatusCodes.includes(status.statusCode);
    })
    .map((status) => `${status.statusCode}-${status.reasonCode}`)
    .join(', ');

  return (
    <Flex align="center">
      <Alert
        size="small"
        type={statementPreferences?.isPaperless ? 'success' : 'warning'}
        title={statementPreferences?.isPaperless ? 'Paperless' : 'Paper'}
      ></Alert>
      <Tooltip
        title={
          !statementPreferences?.canUpdate
            ? `Account is unable to make change due to existing account status(es): ${ineligibileToUpdateText}`
            : undefined
        }
      >
        <Button
          type="link"
          disabled={!statementPreferences?.canUpdate}
          block
          data-testid={'change-statement-preference'}
          onClick={statementPreferencesModal.show}
        >
          {statementPreferences?.isPaperless
            ? 'Enroll in Paper Billing'
            : 'Enroll in Paperless Billing'}
        </Button>
      </Tooltip>
    </Flex>
  );
};

export default StatementPreferences;
